import { Pipe, PipeTransform } from '@angular/core';
import {Area} from "@core/area";
import {AreaFilter} from "@components/areas/list/areaFilter";

@Pipe({
  name: 'areaFilter',
  pure: false
})
export class AreaFilterPipe implements PipeTransform {
  transform(items: Area[], filter: AreaFilter): Area[] {
    if (!items || !filter) {
      return items;
    }

    // filter items array, items which match and return true will be kept, false will be filtered out
    return items.filter((item: Area) => this.applyFilter(item, filter));
  }

  /**
   * Perform the filtering.
   *
   * @param {Area} area The area to compare to the filter.
   * @param {AreaFilter} filter The filter to apply.
   * @return {boolean} True if area satisfies filters, false if not.
   */
  applyFilter(area: Area, filter: AreaFilter): boolean {
    // console.log("checking:" + JSON.stringify(filter));
    if( filter.text ){
      if (area['areaId'].toLowerCase().indexOf(filter.text.toLowerCase()) === -1) {
        return false;
      }

      if (area['name'].toLowerCase().indexOf(filter.text.toLowerCase()) === -1) {
        return false;
      }
    }

    if( filter.active ){
      if( filter.active == 'active' ) {
        if (area.active === false) {
          return false;
        }
      } else {
        if (area.active !== false) {
          return false;
        }
      }
    }

    return true;
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/components/areas/list/area-filter.pipe.ts